const events = ['touchstart', 'keydown', 'mousemove', 'touchmove'];

function addEvents() {
    events.forEach((event) => {
        document.addEventListener(event, insertSpamProtectionValue, true);
    });
}

function removeEvents() {
    events.forEach((event) => {
        document.removeEventListener(event, insertSpamProtectionValue, true);
    });
}

function insertSpamProtectionValue() {
    const fields = document.querySelectorAll('.js-spam-protection-field');
    [...fields].forEach((field) => {
        const form = field.closest('form');

        if (!form) {
            return;
        }

        const stateField = form.querySelector('input[name*=__state]');

        if (stateField) {
            field.value = stateField.value;
        }
    });

    removeEvents();
}

if (document.querySelector('.js-spam-protection-field')) {
    addEvents();
}

// Product choice
const productChoiceWrapper = document.querySelector('.inquiry-form__product-choice');
let product = window.location.hash;

if (productChoiceWrapper && product) {
    const products = document.querySelector('[data-product-choices]').getAttribute('data-product-choices').split(';');
    const selectEl = productChoiceWrapper.querySelector('select');
    product = product.substring(1).replaceAll('%20', ' ');

    productChoiceWrapper.classList.add('shown');
    let i = 1;
    let indexToSelect = 0;

    [...products].forEach(p =>
    {
        if (p == product) {
            indexToSelect = i;
        }

        let option = document.createElement('option');
        option.text = p;
        option.setAttribute('value', p);
        selectEl.add(option);

        i = i + 1;
    });

    selectEl.selectedIndex = indexToSelect;
}


